const WordBadge = ({ word }) => (
  <span className="ms-1 mt-1 p-2 badge rounded-pill bg-dark" key={word}>
    {word}
  </span>
);

export default WordBadge;
